import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditTracking from '../editor/EditTracking';

export const initTrackingValues = {
  tracking: {
    button: ['shop now - button'],
    left_button: ['never show - button'],
    right_button: ['close - button']
  }
};

const SimpleIconModalTracking: FC = () => {
  const tracking = useSelector((state: any) => state.trackings.tracking);

  const style = `
  .root_tracking {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;

    .center {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;      
    }
    .modal_wrapper {
      width: 100%;
      padding: 2rem 0 1rem 0;

      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .title {
      height: 3.5rem;
    }
    .sub_title {
      height: 3rem;
    }

    .btn_wrapper {
      width: 100%;
      padding: 0 1rem;
    }

    .bottom_input {
      width: 1.25rem;
      height: 1.25rem;
    }
    .bottom_wrapper {
      height: 1.25rem;
    }
    .bottom_wrapper .style01,
    .bottom_wrapper .style02 {
      width: 100%;
      height: 2.5rem;
    }

    .tracking_center {
      display: flex;
      align-items: center;
      justify-content: end;
    }
  }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="root_tracking">
        <div className="center">
          <div className="modal_wrapper">
            <div>
              <div className="title" />
              <div className="sub_title" />
            </div>
            <div className="btn_wrapper">
              <EditTracking value={tracking?.button?.[0]} type="button" />
            </div>
          </div>
          <div className="bottom_wrapper">
            <span className="style01 tracking_center">
              <EditTracking
                value={tracking?.left_button?.[0]}
                type="left_button"
              />
            </span>
            <span className="style02 tracking_center">
              <EditTracking
                value={tracking?.right_button?.[0]}
                type="right_button"
              />
            </span>
          </div>
        </div>
      </div>
    </>
  );
};
export default SimpleIconModalTracking;
